"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var rxjs_1 = require("rxjs");
var definitions_1 = require("./definitions");
/**
 * =============================================================================
 * Filter Class
 * =============================================================================
 */
var Filter = /** @class */function () {
  function Filter(exclude) {
    if (exclude === void 0) {
      exclude = false;
    }
    this.exclude = exclude;
    // The filters unique internalID
    // protected internalId: string = this.generateFilterID();
    // every filter has a subject to notify when something changes
    this.updated = new rxjs_1.Subject();
  }
  Filter.prototype.setIdentifier = function (id, silent) {
    if (silent === void 0) {
      silent = false;
    }
    this.id = id || undefined;
    if (!silent) {
      this.updated.next(this);
    }
    return this;
  };
  Filter.prototype.getIdentifier = function () {
    return this.id;
  };
  /** Filter Sorting */
  Filter.prototype.setSort = function (sortConditions) {
    this.sortConditions = sortConditions;
    return this;
  };
  Filter.prototype.getSort = function () {
    return this.sortConditions || [];
  };
  /**
   * Use the filter results or use everything BUT the filter results
   * @param exclude boolean
   */
  Filter.prototype.setExclude = function (exclude) {
    this.exclude = !!exclude;
    this.updated.next(this);
    return this;
  };
  /**
   * Is this filter negated?
   * @param exclude boolean
   */
  Filter.prototype.getExclude = function () {
    return this.exclude;
  };
  /** Subscribe to filter changes. Will notify which filter in the tree changed*/
  Filter.prototype.onChanged = function (callback) {
    return this.updated.subscribe(callback);
  };
  Filter.prototype.toQueryString = function () {
    return this.getSort().map(function (sort) {
      return "" + (sort.direction === definitions_1.IqlSortOperator.DESC ? '-' : '') + sort.by;
    }).join(definitions_1.valueSeparator);
  };
  Filter.prototype.toJson = function (clean) {
    if (clean === void 0) {
      clean = false;
    }
    var filterJson = {};
    if (this.getIdentifier()) {
      filterJson.identifier = this.getIdentifier();
    }
    if (this.getExclude()) {
      // no need to send exclude false as this is the "obvious" default
      filterJson.exclude = this.getExclude();
    }
    if (this.getSort()) {
      filterJson.sort = this.getSort();
    }
    // the child queries will deconstruct the object returned here so we can return an empty object regardless of the clean flag
    return filterJson;
  };
  /**
   * Convert this filter object to a Human readable format
   * @return     string
   */
  Filter.prototype.toHumanReadable = function () {
    var sorts = this.getSort().map(function (sort) {
      return sort.by + " " + sort.direction;
    }).join(definitions_1.HRvalueSeparator);
    return this.getSort().length ? definitions_1.HRfilterSort + " " + sorts : '';
  };
  Filter.prototype.equals = function (other, ignoreSort) {
    if (ignoreSort === void 0) {
      ignoreSort = false;
    }
    // Make sure we look at the same ID (if any one has an ID, they need to be equal)
    if ((this.getIdentifier() || other.getIdentifier()) && this.getIdentifier() !== other.getIdentifier()) {
      return false;
    }
    // Make sure we look at the same exclude
    if (!!this.getExclude() !== !!other.getExclude()) {
      return false;
    }
    return this.compareSort(other, ignoreSort);
  };
  Filter.prototype.compareSort = function (other, ignoreSort) {
    if (ignoreSort) {
      return true;
    }
    var ours = this.getSort();
    var theirs = other.getSort();
    if (ours.length !== theirs.length) {
      return false;
    }
    return ours.reduce(function (result, current, index) {
      return result && current.by === theirs[index].by && current.direction === theirs[index].direction;
    }, true);
  };
  /**
   * @return A 4 digit random uri for use as filterID wherever required
   */
  Filter.prototype.generateFilterID = function () {
    var BASE62 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    var id = '';
    for (var i = 0; i < 4; i++) {
      id += BASE62.charAt(Math.random() * 62);
    }
    return id;
  };
  /**
   * Trigger the update-notification cycle
   *
   * Can be useful to notify subscribers once about a set of silent changes
   */
  Filter.prototype.triggerUpdate = function () {
    this.updated.next(this);
  };
  return Filter;
}();
exports.Filter = Filter;